/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { loaderView as LoaderView, PrintOptions } from '../../shared/index';
import { isEmpty, trim } from 'lodash';
import { togglePswd } from '../../modules/utils';

const suiteFileds = [
  { id: 'customerName', displayLabel: 'Customer Name', fieldType: 'input' },
  { id: 'firstname', displayLabel: 'First Name', fieldType: 'input' },
  { id: 'lastname', displayLabel: 'Last Name', fieldType: 'input' },
  { id: 'email', displayLabel: 'Email', fieldType: 'input' },
  { id: 'fromAD', displayLabel: 'AD User', fieldType: 'adcheck' },
  { id: 'password', displayLabel: 'Password', fieldType: 'password' },
  { id: 'fromDate', displayLabel: 'Valid From', fieldType: 'date' },
  { id: 'tillDate', displayLabel: 'Valid To', fieldType: 'date' },
  { id: 'projectManagement', displayLabel: 'Integration config', fieldType: 'select' },
  { id: 'intelligence', displayLabel: 'Intelligence', fieldType: 'checkbox' }
];

export const superAdminView = (props) => {
  const {
    showCustomer,
    onSaveClick,
    onCancelClick,
    isLoading,
    selected,
    showCustomerData
  } = props;
  let view = null;
  if (isLoading) {
    view = <LoaderView />;
  } else {
    const isValidCustomer =
      !isEmpty(trim(selected.customerName)) &&
      !isEmpty(trim(selected.email)) &&
      !isEmpty(trim(selected.firstname)) &&
      !isEmpty(trim(selected.lastname)) &&
      !isEmpty(trim(selected.email)) &&
      !isEmpty(trim(selected.projectManagement)) &&
      (!isEmpty(trim(selected.password)) || selected.fromAD) &&
      !isEmpty(selected.fromDate) &&
      !isEmpty(selected.tillDate);

    view = (
      <React.Fragment>
        {printButtons(props)}
        {showCustomerData ? (
          <div className='superAdmin__userData mt-4'>
            {printCustomerData(props)}
          </div>
        ) : (
          ''
        )}
        {showCustomer ? (
          <div className='superAdmin__customerForm mt-4'>
            {printCustomerForm(props)}
            <div className='text-center mt-4'>
              <button
                type='button'
                onClick={(e) => {
                  onSaveClick(e, false, 'customerForm');
                }}
                className={`btn btn-color mx-3 ${!isValidCustomer ? 'btn--disable' : ''
                  }`}
                disabled={!isValidCustomer}
              >
                Save
              </button>
              <button
                type='button'
                onClick={() => onCancelClick('customer')}
                className='btn btn-color'
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }
  return (
    <div className='page--superAdmin'>
      <div className='superAdmin__container'>{view}</div>
    </div>
  );
};

const printCustomerData = (payload) => {
  const { allCustomer, onEditClicked, onDeleteClicked } = payload;
  return (
    <table className='table table-striped'>
      <thead className='thead-light'>
        <tr>
          <th>User Name</th>
          <th>Customer Name</th>
          <th>Email</th>
          <th>Valid From</th>
          <th>Valid To</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody className='table__body'>
        {allCustomer?.map((item, index) => {
          return (
            <tr key={index}>
              <td>{item.firstname + ' ' + item.lastname}</td>
              <td>{item.customerName}</td>
              <td>{item.email}</td>
              <td>{item.fromDate}</td>
              <td>{item.tillDate}</td>
              <td className='table__row__td--superactions'>
                <a title='Edit' onClick={(eve) => onEditClicked(eve, item)}>
                  <i className='fa fa-pencil' />
                </a>
                <a
                  title='Delete'
                  className='ml-5'
                  onClick={(eve) => onDeleteClicked(eve, item)}
                >
                  <i className='fa fa-trash ' />
                </a>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const printButtons = (payload) => {
  const { handleCustomer, showCustomer } = payload;
  return (
    <div className='superAdmin__left text-center'>
      {showCustomer ? (
        ''
      ) : (
        <button className='btn btn-color my-1' onClick={() => handleCustomer()}>
          <i className='fa fa-plus btn__icon'></i>Add New User
        </button>
      )}
    </div>
  );
};

const printField = ({ fieldType, id, selected, onChange, payload }) => {
  let elementProps = {
    className: 'form-control',
    value: selected[id],
    disabled: id === 'customerName' && payload.editMode,
    onChange: (e) => onChange({ id, value: e.currentTarget.value })
  };

  switch (fieldType) {
    case 'input':
      return <input type='text' {...elementProps} />;
    case 'password':
      return (
        <>
          <input type='password' id='userPswd' {...elementProps} />
          <span
            id='togglePassword'
            onClick={(eve) => togglePswd(eve, 'userPswd')}
            className='fa fa-fw fa-eye pswd-toggle'
          ></span>
        </>
      );
    case 'date':
      return <input type='date' {...elementProps} />;
    case 'adcheck':
      return <div className='form-check form-check-inline mt-2'>
        <input
          className='form-check-input'
          type='checkbox'
          id='fromAD'
          value={selected['fromAD']}
          checked={selected['fromAD']}
          onChange={(e) =>
            onChange({ id: 'fromAD', value: e.currentTarget.checked })
          }
        />
      </div>
    case 'select':
      return <select
          onChange={(eve) =>
            onChange({
              id: 'projectManagement',
              value: eve.currentTarget.value
            })
          }
          className='form-select'
        >
          <PrintOptions
            value={selected[id]}
            options={payload?.TypeOption}
          />
        </select>
    case 'checkbox':
      return (
        <>
          <div className='form-check form-check-inline mt-2'>
            <input
              className='form-check-input'
              type='checkbox'
              id='testDesign'
              value={selected['testDesign']}
              checked={selected['testDesign']}
              onChange={(e) =>
                onChange({ id: 'testDesign', value: e.currentTarget.checked })
              }
            />
            <label className='form-check-label' htmlFor='testDesign'>
              Test Design
            </label>
          </div>
          <div className='form-check form-check-inline mt-2'>
            <input
              className='form-check-input'
              type='checkbox'
              id='testDataManagement'
              value={selected['testDataManagement']}
              checked={selected['testDataManagement']}
              onChange={(e) =>
                onChange({
                  id: 'testDataManagement',
                  value: e.currentTarget.checked
                })
              }
            />
            <label className='form-check-label' htmlFor='testDataManagement'>
              Test Data Management
            </label>
          </div>
        </>
      );
    default:
      return null;
  }
};

const printCustomerForm = (payload) => {
  const { onChange, selected } = payload;
  return suiteFileds.map((field) => {
    const { fieldType, displayLabel, id } = field;
    return (
      <div key={field.id} className='row mt-3'>
        <div className='col-sm-3'></div>
        <label className='col-sm-2 col-form-label'>{displayLabel}</label>
        <div
          className={`${fieldType === 'checkbox' ? 'col-sm-7' : 'col-sm-3'}`}
        >
          {printField({
            fieldType,
            id,
            selected,
            onChange,
            payload
          })}
        </div>
      </div>
    );
  });
};
